
import { ProductsKeys } from '@/i18n/types/products.types';

export const products: Record<ProductsKeys, string> = {
  products: 'Products',
  productImage: 'Product image',
  addToCart: 'Add to Cart',
  loadingProducts: 'Loading products...',
  noProductsAvailable: 'No products available',
  noProductsMessage: 'No products found. Please check back later.',
  errorLoadingProducts: 'Error loading products',
  tryAgain: 'Try Again',
  cart: 'Cart',
  securePaymentInfo: 'Secure payment information',
  securePaymentDescription: 'Your payments are processed securely by Culqi. Your card data is never stored on our servers.',
  continueShopping: 'Continue Shopping',
  viewCart: 'View Cart',
  productPrice: 'Price',
  productDescription: 'Description',
};
